import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalAccountsService } from "services/ClientPortalAccountsService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  InitialGet: true,
  AccountBalance: 0,
  Loading: false,
};

export const overallAccountsBalanceSlice = createSlice({
  name: "OverallAccountsBalance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOverallAccountBalance.pending, (state) => {
        if (state.InitialGet) {
          state.Loading = true;
        }
      })
      .addCase(getOverallAccountBalance.fulfilled, (state, action) => {
        state.AccountBalance = action.payload;
        state.Loading = false;
        state.InitialGet = false;
      })
      .addCase(getOverallAccountBalance.rejected, (state) => {
        state.AccountBalance = 0;
        state.Loading = false;
        state.InitialGet = false;
      });
  },
});

export const getOverallAccountBalance = createAsyncThunk<number>(
  "OverallAccountsBalance/getOverallAccountBalance",
  async () => {
    const accountsService = container.get<IClientPortalAccountsService>(SERVICE_TYPES.ClientPortalAccountsService);
    return await accountsService.getOverallOutstandingBalance();
  }
);

export const selectAccountBalance = (state: RootState) => {
  return state.overallAccountsBalance.AccountBalance;
};

export const selectLoadingAccountBalance = (state: RootState) => {
  return state.overallAccountsBalance.Loading;
};

export default overallAccountsBalanceSlice.reducer;
